export default __webpack_public_path__ + "static/media/Regular.351b7924.woff2";